import { render, staticRenderFns } from "./postscript.vue?vue&type=template&id=34943b16&scoped=true&lang=pug"
import script from "./postscript.vue?vue&type=script&lang=js"
export * from "./postscript.vue?vue&type=script&lang=js"
import style0 from "./postscript.vue?vue&type=style&index=0&id=34943b16&prod&lang=scss&scoped=true"
import style1 from "./postscript.vue?vue&type=style&index=1&id=34943b16&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34943b16",
  null
  
)

export default component.exports